export default __webpack_public_path__ + "static/media/get-started.da2c753e.png";